import {
  BaseAddEntityCommand,
  type BaseAddEntityParams,
} from "./BaseAddEntityCommand";

export type AddEntitiesParams = BaseAddEntityParams;

/**
 * Command for adding multiple entities (e.g., shape + hatch) with soft-delete undo.
 * All entities are treated as a single undo/redo operation.
 */
export class AddEntitiesCommand extends BaseAddEntityCommand {}
